export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_SUCCESS_FAILED = 'GET_USERS_SUCCESS_FAILED';
